import App from "../Core/App";

import BaseComponent from "./BaseComponent";
import LayoutHelper from "../Helper/Layout";

export default class Textpic extends BaseComponent {
    constructor() {
        super();

        this.zoomLock = 0;
        this.isZoomed = 0;
        this.oldMousePos = [0, 0];
        this.oldTouchPos = {x0: -1, y0: -1, x1: -1, y1: -1};
        this.imageDimensions = [0, 0, 'none'];

        if($('.blb-images.gallery').length != 0) this.makeAsideGallery();
        this._onResize();
        this._bindListener('click', this._onPreviewClick, '.blb-gallery > .blb-image');
        this._bindListener('click', this._onModalClick, '.blb-image > .blb-has-modal');
        this._bindListener('click', function(e){$(e.target).parents('.blb-image').find('.blb-has-modal').click()}, '.blb-modal-open-btn');

        // firefox fallback for css :has()-selector
        let elem = $('#c16230');
        if (elem) {
            elem.parent().css({'flex-direction': 'row', 'flex-wrap': 'wrap'});
        }
    }

    makeAsideGallery(){
        // make gallery_aside object to be used in breakpoints > xs (execute before onResize!)
        $('.blb-images.gallery').each(function(i){
            let asideGallery = "<div class='blb-box blb-box-absolute no-print index_"+i+"'><div class='blb-images gallery-aside'>";
            asideGallery += $(this)[0].innerHTML;
            asideGallery += "</div></div>";

            $('.blb-container').first().append(asideGallery);
        });
    }

    _onPreviewClick( e ){
        var displayed = $(e.target).parents('.blb-images').children('.blb-image').first();
        $(displayed).html( $(e.target).parent().html().replace(/style="[^"]*"/, "") ); //deletes style attributes before copying
        if($(e.target).hasClass('blb-has-modal')){
            $(displayed).children('img').bind('click', this._onModalClick.bind(this));
            $(displayed).find('.blb-modal-open-btn').bind('click', function(e){$(e.target).parents('.blb-image').find('.blb-has-modal').click()});
        }
    }

    _onResize(){
        if(!LayoutHelper.isCollapsedView()){
            let sidebar = $('.blb-box-sidebar').length > 0 ? $('.blb-box-sidebar > .blb-box-header')[0] : false;
            let subnav = $('.blb-subnav').length > 0 ? $('.blb-subnav')[0] : false;

            if(sidebar){
                let aWidth = subnav.offsetWidth;
                let aPosX = subnav.offsetLeft;
                let aPosY_min = sidebar.offsetTop;
                if(subnav){
                    aPosY_min += $(subnav).find('.blb-box-header')[0].clientHeight;
                    aPosY_min += $(subnav).find('.blb-box-content > .blb-box-content-wrapper')[0].clientHeight;
                    aPosY_min += 20;
                }
                if(sidebar.offsetLeft == subnav.offsetLeft) aPosY_min += sidebar.offsetHeight+20;

                    $('.blb-images.gallery').each(function(i){
                        let aPosY = Math.max($(this).parent().parent()[0].offsetTop, aPosY_min);
                        let asideGallery = $(".blb-box-absolute.index_"+i);
                        asideGallery.css({'width': aWidth, 'left': aPosX, 'top': aPosY});

                        let prevHeight = Math.min(aWidth*0.25, 100);
                        $(asideGallery).find('.blb-gallery > .blb-image > img').each(function(){
                            let aspect = $(this)[0].naturalWidth / $(this)[0].naturalHeight;
                            $(this).parent().css({'width': aspect*prevHeight+'px', 'height': prevHeight+'px'});
                            $(this).css('maxWidth', aspect*prevHeight+'px');
                        });

                        aPosY_min = aPosY + $(asideGallery)[0].scrollHeight;
                    });
            }
        }

        $('.blb-images.gallery').each(function(){
            let height = $(this[0]).width;
            $(this).find('.blb-gallery > .blb-image > img').each(function(){
                let aspect = $(this)[0].naturalWidth / $(this)[0].naturalHeight;
                $(this).parent().css({'width': aspect*height+'px', 'height': height+'px'});
                $(this).css('maxWidth', aspect*height+'px');
            });

        });
    }

    zoomImage( zoom, posX, posY ){
        var newZoom;
        var image = $('.blb-image-modal .blb-image.active > img');
        var mtrx = $(image).css('transform').match(/(-*\d+\.*\d*)/gm);
        var oldZoom = parseFloat(mtrx[0]);
        if( posX == null || posY == null ){
            if( zoom === 1 ){
                newZoom = oldZoom < 1.0 ? 1.0 : 2.0;
            } else if( zoom === -1 ){
                newZoom = 1.0;
            }
            $(image).css('transition', 'transform 500ms');
            setTimeout(function(){ $(image).css('transition',''); }, 500);
            $(image).css('transform', 'matrix('+newZoom+',0,0,'+newZoom+',0,0)');
        } else {
            var rect = $(image)[0].getBoundingClientRect();
            var midX = rect.left + rect.width*0.5;
            var midY = rect.top + rect.height*0.5;

            if (zoom == 1) {
                newZoom = Math.min(oldZoom + 0.1, 3.0);
            } else if (zoom == -1) {
                newZoom = Math.max(oldZoom - 0.1, 0.5);
            } else {
                newZoom = Math.max(Math.min(oldZoom + zoom*0.002, 3.0), 0.5);
            }

            var nX = parseFloat(mtrx[4]);
            var nY = parseFloat(mtrx[5]);
            if( newZoom != oldZoom && zoom === 1.0 ){
                nX -= 0.1*( posX-midX )/oldZoom;
                nY -= 0.1*( posY-midY )/oldZoom;
            } else if( zoom === -1.0 ){
                nX += 0.1*( posX-midX )/oldZoom;
                nY += 0.1*( posY-midY )/oldZoom;
            }
            if( newZoom < 1.5 && zoom === -1.0 ){
                var del = Math.max( (newZoom-1.0)*2.0, 0.0 );
                nX *= del;
                nY *= del;
            }
            $(image).css('transform', 'matrix(' + newZoom + ',0,0,' + newZoom + ',' + nX + ',' + nY + ')');
        }

        // update zoom buttons
        var zoomOutBtn = $(image).next().children('.blb-image-description').children('.blb-modal-zoom-out-btn');
        var zoomInBtn = $(image).next().children('.blb-image-description').children('.blb-modal-zoom-in-btn');
        if( newZoom > 1.0 && $(zoomInBtn).hasClass('active') ){
            $(image).css('cursor','move');
            $(zoomInBtn).removeClass('active');
            $(zoomOutBtn).addClass('active');
            this.isZoomed = 1;

        } else if( newZoom <= 1.0 && $(zoomOutBtn).hasClass('active') ){
            $(image).css('cursor','');
            $(zoomInBtn).addClass('active');
            $(zoomOutBtn).removeClass('active');
            this.isZoomed = 0;
        }
    }

    moveImage( delX, delY ){
        var image = $('.blb-image-modal .blb-image.active > img');
        var mtrx = $(image).css('transform').match(/(-*\d+\.*\d*)/gm);
        var rect = $(image)[0].getBoundingClientRect();
        var parentRect = $(image).parent()[0].getBoundingClientRect();

        var nx = parseFloat(mtrx[4]);
        if( delX > 0 ){
            if( rect.left+delX < parentRect.left ) nx += delX;
        } else {
            if( rect.right+delX > parentRect.right ) nx += delX;
        }
        var ny = parseFloat(mtrx[5]);
        if( delY > 0 ){
            if( rect.top+delY < parentRect.top ) ny += delY;
        } else {
            if( rect.bottom+delY > parentRect.bottom ) ny += delY;
        }
        $(image).css('transform','matrix('+mtrx[0]+','+mtrx[1]+','+mtrx[2]+','+mtrx[3]+','+nx+','+ny+')');
    }

    _onModalClick( e ) {
        // check if click is on preview image
        if($(e.target).parents('.blb-gallery').length != 0) return;
        // add modal to body
        var modal = "<div class='blb-image-modal'><div class='blb-modal-close-btn'></div><div class='blb-modal-gallery'>";
        var images = [];

        // Find images
        if( $(e.target).parents('.blb-images.gallery,.blb-images.gallery-aside').length > 0 ) { // Layout: image in right
          images = $(e.target).parents('.blb-images.gallery,.blb-images.gallery-aside').find('.blb-image');
          if($(e.target).parents('.blb-images.gallery,.blb-images.gallery-aside').find('.blb-gallery').length != 0){
              images = $(e.target).parents('.blb-images.gallery,.blb-images.gallery-aside').find('.blb-gallery > .blb-image');
          }
        }
        else if( $(e.target).parents('.blb-textpic').length > 0 ) { // Inside textpic element, aka inside content box
           images = $(e.target).parents('.blb-images').find('.blb-image')
        }

        console.log("Opening modal with images: ", images, $(e.target));

        $(images).each(function(){
            if ($(this).children('img').prop('src') === $(e.target).prop('src')) {
                modal += "<div class='blb-image active'>";
            } else {
                modal += "<div class='blb-image'>";
            }
            modal += $(this).html().replace(/style="[^"]*"/, ""); //remove style first
            modal += "</div>";
        });



        modal += "</div>";
        if (images.length > 1) modal += "<p class='blb-modal-previous-btn'></p><p class='blb-modal-next-btn'></p>";
        modal += "</div>";

        $('body').addClass('blb-modal-open')
        $('body').append(modal);

        $('.blb-modal-gallery img').each(function(){
            var aspectRatio = $(this).attr('width') / $(this).attr('height');
            var width = $(this).parent().width();
            var height = width / aspectRatio;
            if( $(this).parent().height() < height ){
                height = $(this).parent().height();
                width = height * aspectRatio;
            }
            $(this).css('width', width+'px');
            $(this).css('height', height+'px');
            $(this).siblings('.blb-image-description-wrapper').children('.blb-image-description').prepend("<div class='blb-modal-zoom-in-btn active'></div><div class='blb-modal-zoom-out-btn'></div>");
        });

        // callbacks for buttons
        var closeBtnCallback = function (e) {
            $('body').removeClass('blb-modal-open');
            $('.blb-image-modal').remove();
        }
        var zoomImgBtnCallback = function (e) {
            //prevent retriggering during animation
            if (this.zoomLock === 1) return;
            this.zoomLock = 1;
            setTimeout(function () {
                this.zoomLock = 0;
            }.bind(this), 500);

            if ($(e.target).hasClass('blb-modal-zoom-in-btn')) {
                this.zoomImage(1);
            } else if ($(e.target).hasClass('blb-modal-zoom-out-btn')) {
                this.zoomImage(-1);
            }
        }
        var switchImgBtnCallback = function (e) {
            var oldImg = $('.blb-image-modal .blb-image.active');
            var newImg;
            if ($(e.target).hasClass('blb-modal-next-btn')) {
                newImg = $(oldImg).next('.blb-image');
                if (newImg.length === 0) newImg = $('.blb-image-modal .blb-image').first();
            } else if ($(e.target).hasClass('blb-modal-previous-btn')) {
                newImg = $(oldImg).prev('.blb-image');
                if (newImg.length === 0) newImg = $('.blb-image-modal .blb-image').last();
            }
            $(oldImg).removeClass('active');
            $(newImg).children('img').css('transform', '');
            $(newImg).addClass('active');
        }
        var scrollCallback = function(e){
            this.zoomImage(e.deltaY, e.clientX, e.clientY);
            e.preventDefault();
            e.stopPropagation();
        }
        var dragCallback = function (e){
            e.preventDefault();
            if (this.isZoomed === 0) return;
            this.oldMousePos = [e.clientX, e.clientY];
            $(document).bind('mousemove', function (e) {
                var delX = e.clientX - this.oldMousePos[0];
                var delY = e.clientY - this.oldMousePos[1];
                this.oldMousePos = [e.clientX, e.clientY];

                this.moveImage(delX, delY);
            }.bind(this));
            $(document).bind('mouseup', function (e) {
                $(document).unbind('mousemove mouseup');
            });
        }
        var touchResetCallback = function(e){
            this.oldTouchPos = {x0: -1, y0: -1, x1: -1, y1: -1};
            e.preventDefault();
        }
        var touchMoveCallback = function(e){
            let isMultiTouch = e.touches.length > 1 ? true : false;
            //does nothing if any needed value is -1
            if(!isMultiTouch && this.oldTouchPos.x0 !== -1 && this.oldTouchPos.y0 !== -1){
                let del = {x: e.touches[0].clientX - this.oldTouchPos.x0, y: e.touches[0].clientY - this.oldTouchPos.y0};
                this.moveImage(del.x, del.y);

            } else if(isMultiTouch && this.oldTouchPos.x0 !== -1 && this.oldTouchPos.y0 !== -1
                                    && this.oldTouchPos.x1 !== -1 && this.oldTouchPos.y1 !== -1){
                let oldMiddle = {x: this.oldTouchPos.x0 + (this.oldTouchPos.x1-this.oldTouchPos.x0)*0.5,
                                 y: this.oldTouchPos.y0 + (this.oldTouchPos.y1-this.oldTouchPos.y0)*0.5};
                let oldDist = Math.sqrt(Math.pow(this.oldTouchPos.x1-this.oldTouchPos.x0, 2)+Math.pow(this.oldTouchPos.y1-this.oldTouchPos.y0, 2));
                let newMiddle = {x: e.touches[0].clientX + (e.touches[1].clientX-e.touches[0].clientX)*0.5,
                                 y: e.touches[0].clientY + (e.touches[1].clientY-e.touches[0].clientY)*0.5};
                let newDist = Math.sqrt(Math.pow(e.touches[1].clientX-e.touches[0].clientX, 2)+Math.pow(e.touches[1].clientY-e.touches[0].clientY, 2));

                this.zoomImage(newDist-oldDist, oldMiddle.x, oldMiddle.y);
                this.moveImage(newMiddle.x-oldMiddle.x, newMiddle.y-oldMiddle.y);
            }
            this.oldTouchPos.x0 = e.touches[0].clientX;
            this.oldTouchPos.y0 = e.touches[0].clientY;
            this.oldTouchPos.x1 = e.touches[1] ? e.touches[1].clientX : -1;
            this.oldTouchPos.y1 = e.touches[1] ? e.touches[1].clientY : -1;
            e.preventDefault();
        }



        $('.blb-image-modal > .blb-modal-next-btn').bind('click', switchImgBtnCallback);
        $('.blb-image-modal > .blb-modal-previous-btn').bind('click', switchImgBtnCallback);
        $('.blb-image-modal > .blb-modal-close-btn').bind('click', closeBtnCallback);
        $('.blb-image-modal .blb-modal-zoom-in-btn').bind('click', zoomImgBtnCallback.bind(this));
        $('.blb-image-modal .blb-modal-zoom-out-btn').bind('click', zoomImgBtnCallback.bind(this));
        $('.blb-image-modal img').bind('DOMMouseScroll mousewheel', scrollCallback.bind(this));
        $('.blb-image-modal img').bind('mousedown', dragCallback.bind(this));
        $('.blb-image-modal img').bind('touchstart touchend touchcancel', touchResetCallback.bind(this));
        $('.blb-image-modal img').bind('touchmove', touchMoveCallback.bind(this));
    }
}
